import { render } from "./index.vue?vue&type=template&id=096deac5"
const script = {}

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=096deac5&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__